export class AiAgentsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAiAgents() {
    return this.#http.get('/ai-agents');
  }

  async getAiAgentTemplates() {
    return this.#http.get('/ai-agents/templates');
  }

  async createAiAgent(body) {
    return this.#http.post('/ai-agents', body);
  }

  async updateAiAgent({ id, ...body }) {
    return this.#http.put(`/ai-agents/${id}`, body);
  }

  async deleteAiAgent(id) {
    return this.#http.delete(`/ai-agents/${id}`);
  }

  async cloneAiAgent(id) {
    return this.#http.post(`/ai-agents/${id}/clone`);
  }

  async enableAiAgent(id) {
    return this.#http.get(`/ai-agents/${id}/enable`);
  }

  async disableAiAgent(id) {
    return this.#http.get(`/ai-agents/${id}/disable`);
  }
}
